var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldPenAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.69 2.99A4.448 4.448 0 0 0 2 6.5c0 .84.24 1.64.65 2.32.54.9 1.39 1.6 2.41 1.94.45.16.93.24 1.44.24 1.14 0 2.17-.42 2.96-1.12a4.455 4.455 0 0 0 1.37-2.18c.11-.38.17-.79.17-1.2a4.494 4.494 0 0 0-7.31-3.51zm3.58 4.26v.93a.749.749 0 1 1-1.5 0v-.93H4.8c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h.97v-.93a.749.749 0 1 1 1.5 0v.93h.89a.749.749 0 1 1 0 1.5h-.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.64 22.39c-.65.08-1.23-.02-1.72-.26a2.59 2.59 0 0 1-1.19-1.19c-.24-.49-.33-1.06-.26-1.7l.85-7.15c.08.03.16.06.24.08.61.22 1.26.33 1.94.33 1.46 0 2.87-.53 3.94-1.48a5.962 5.962 0 0 0 2-3.71c.01-.05.01-.1.01-.15l.17.01 6.08 6.09.26 4.42c.25 2.48-.61 3.34-2.96 3.61l-9.36 1.1zM19.93 11.592c-.39.24-.89.19-1.21-.14l-4.43-4.43a.982.982 0 0 1-.14-1.21l1.31-2.07c.8-1.26 2.4-1.32 3.59-.15l3.11 3.11c1.09 1.11 1.02 2.83-.16 3.58l-2.07 1.31z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldPenAdd);
export default __webpack_public_path__ + "static/media/vuesax-bold-pen-add.5273121a83cfe4eff8709015acdc1970.svg";
export { ForwardRef as ReactComponent };